// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17Yvh","content":"styles_content__1W8GS"};